import e from "./_baseIsTypedArray.js";
import y from "./_baseUnary.js";
import "./_nodeUtil.js";
import { _ as s } from "../../_virtual/_nodeUtil.js";
var o = e, p = y, r = s.exports, a = r && r.isTypedArray, d = a ? p(a) : o, T = d;
export {
  T as default
};
//# sourceMappingURL=isTypedArray.js.map
